import type { CopyShape } from "@tami/core/intl";

import type { SIDEBAR_COPY_PT_BR } from "../sidebar.copy";

export const SIDEBAR_COPY_EN_US: CopyShape<typeof SIDEBAR_COPY_PT_BR> = {
  toggle: "Toggle sidebar",
  mobileTitle: "Menu",
  mobileDescription: "Mobile navigation",
};
